import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { em, color, rgba } from '../../../utils/styles'

const InputBase = styled.input`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin: 0;
  border: 0;
  padding: ${em(6)} 0;
  min-width: 0;
  flex-grow: 1;
  background: none;
  vertical-align: middle;
  line-height: 1;
  font-size: 1em;
  font-weight: ${theme('fontWeighs.regular')};
  color: ${color('base')};
  white-space: normal;

  &:focus {
    outline: 0;
  }

  &[type=search],
  &[type=number] {
    -webkit-appearance: textfield;
  }
  &[type=number]::-webkit-outer-spin-button,
  &[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: ${rgba('base', 0.4)};
  }

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px #fff inset;
  }
  &::-ms-clear, &::-ms-reveal {
    display: none;
  }
`

export default InputBase
